import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import {
  IProductDetails,
  ISimilarProducts,
  ICreateAndFetchProductChat,
} from 'services/api/product';
import * as Types from './types';
import * as ProductService from 'services/api/product';
import { IClientCollectionsData } from 'services/api/client';
import {
  ITopicListByCategoryOutput,
  ITopicListOutput,
} from 'services/api/topic';

export interface IState {
  productDetails: {
    status: StateStatus | null;
    data: IProductDetails | null;
  };
  activityFeed: {
    status: StateStatus | null;
    data: any | null;
  };
  similarProducts: {
    status: StateStatus | null;
    data: ISimilarProducts[] | null;
  };
  customerName: {
    status: StateStatus | null;
    data: any;
  };
  addBookViewing: {
    status: StateStatus | null;
  };
  addRequestInfo: {
    status: StateStatus | null;
  };
  existingBookViewing: {
    status: StateStatus | null;
    data: any;
  };
  existingRequestInfo: {
    status: StateStatus | null;
    data: any;
  };
  cancelAppointment: {
    status: StateStatus | null;
  };
  addToFavourite: {
    status: StateStatus | null;
  };
  removeFromFavourite: {
    status: StateStatus | null;
  };
  chatGroupDetails: {
    status: StateStatus | null;
    data: ICreateAndFetchProductChat | null;
  };
  sharing: {
    status: StateStatus | null;
    data: any;
  };
  listVieweds: {
    status: StateStatus | null;
    data: ProductService.IViewedListOutput[] | null;
  };
  addFavourite: {
    data: number | null;
  };
  clientCollectionsPersonal: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  addCollections: {
    status: StateStatus | null;
  };
  addSharingProduct: {
    status: StateStatus | null;
  };
  topicList: {
    status: StateStatus | null;
    data: ITopicListOutput | null;
  };
  subscribeToNewsLetter: {
    status: StateStatus | null;
  };
  topicListByCategory: {
    status: StateStatus | null;
    data: ITopicListByCategoryOutput[] | null;
  };
}

const initialState: IState = {
  productDetails: {
    status: null,
    data: null,
  },
  activityFeed: {
    status: null,
    data: null,
  },
  similarProducts: {
    status: null,
    data: null,
  },
  customerName: {
    status: null,
    data: [],
  },
  addBookViewing: {
    status: null,
  },
  addRequestInfo: {
    status: null,
  },
  existingBookViewing: {
    status: null,
    data: null,
  },
  existingRequestInfo: {
    status: null,
    data: null,
  },
  cancelAppointment: {
    status: null,
  },
  addToFavourite: {
    status: null,
  },
  removeFromFavourite: {
    status: null,
  },
  chatGroupDetails: {
    status: null,
    data: null,
  },
  sharing: {
    status: null,
    data: null,
  },
  listVieweds: {
    status: null,
    data: null,
  },
  addFavourite: {
    data: null,
  },
  clientCollectionsPersonal: {
    status: null,
    data: null,
  },
  addCollections: {
    status: null,
  },
  addSharingProduct: {
    status: null,
  },
  topicList: {
    status: null,
    data: null,
  },
  subscribeToNewsLetter: {
    status: null,
  },
  topicListByCategory: {
    status: null,
    data: null,
  },
};

const ProductDetailsReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PRODUCT_ACTIVITY_FEED:
      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SET_SIMILAR_PRODUCTS:
      return {
        ...state,
        similarProducts: {
          ...state.similarProducts,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: {
          ...state.customerName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.ADD_BOOK_VIEWING:
      return {
        ...state,
        addBookViewing: {
          ...state.addBookViewing,
          status: action.status || null,
        },
      };
    case Types.ADD_REQUEST_INFO:
      return {
        ...state,
        addRequestInfo: {
          ...state.addRequestInfo,
          status: action.status || null,
        },
      };
    case Types.SET_EXISTING_BOOKVIEWING:
      return {
        ...state,
        existingBookViewing: {
          ...state.existingBookViewing,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_EXISTING_REQUESTINFO:
      return {
        ...state,
        existingRequestInfo: {
          ...state.existingRequestInfo,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.CANCEL_APPOINTMENT:
      return {
        ...state,
        cancelAppointment: {
          ...state.cancelAppointment,
          status: action.status || null,
        },
      };
    case Types.ADD_TO_FAVOURITE:
      return {
        ...state,
        addToFavourite: {
          ...state.addToFavourite,
          status: action.status || null,
        },
        ...(action.status === StateStatus.Success
          ? {
              productDetails: {
                ...state.productDetails,
                data: {
                  ...(state.productDetails.data as IProductDetails),
                  favourite: true,
                },
              },
            }
          : {}),
      };
    case Types.REMOVE_FROM_FAVOURITE:
      return {
        ...state,
        removeFromFavourite: {
          ...state.removeFromFavourite,
          status: action.status || null,
        },
        ...(action.status === StateStatus.Success
          ? {
              productDetails: {
                ...state.productDetails,
                data: {
                  ...(state.productDetails.data as IProductDetails),
                  favourite: false,
                },
              },
            }
          : {}),
      };
    case Types.CHATGROUP_DETAILS:
      return {
        ...state,
        chatGroupDetails: {
          ...state.chatGroupDetails,
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_SHARING_PRODUCT:
      return {
        ...state,
        sharing: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_LIST_VIEWED:
      return {
        ...state,
        listVieweds: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.ADD_FAVOURITE:
      return {
        ...state,
        addFavourite: {
          data: action.data,
        },
      };
    case Types.SET_CLIENT_COLLECTION_PERSONAL:
      return {
        ...state,
        clientCollectionsPersonal: {
          ...state.clientCollectionsPersonal,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_ADD_COLLECTIONS:
      return {
        ...state,
        addCollections: {
          ...state.addCollections,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_SHARING_PRODUCT:
      return {
        ...state,
        addSharingProduct: {
          ...state.addSharingProduct,
          status: action.status || null,
        },
      };
    case Types.SET_TOPIC_LIST:
      return {
        ...state,
        topicList: {
          ...state.topicList,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SUBSCRIBE_TO_NEWS_LETTER:
      return {
        ...state,
        subscribeToNewsLetter: {
          ...state.subscribeToNewsLetter,
          status: action.status || null,
        },
      };
    case Types.RESET:
      return {
        ...initialState,
      };
    case Types.SET_TOPIC_LIST_BY_CATEGORY:
      return {
        ...state,
        topicListByCategory: {
          ...state.topicListByCategory,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.topicListByCategory.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ProductDetailsReducer;
